import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-multiselect-benefits',
    templateUrl: './question-multiselect-benefits.component.html',
    styleUrls: ['./question-multiselect-benefits.component.scss'],
    standalone: false
})
export class QuestionMultiselectBenefitsComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() items: any[] = [];
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `multi-select-benefits-${newGuid()}`;

  constructor() {

  }

  ngOnInit(): void {
  }

  checkMultiSelect(): void {
    const selectedOptions = [];
    const checkboxes = document.getElementsByName(`${this.uniqueControlName}`);

    // @ts-ignore
    for (const c of checkboxes) {
      const el = c as HTMLInputElement;
      if (el.checked) {
        selectedOptions.push(el.value);
      }
    }
    if (selectedOptions?.length) {
      this.submitAnswer(selectedOptions.join('|'));
    }
  }

  submitAnswer(value: any): void {
    if (this.question) {
      this.question.answer = value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(value);
    }
  }



}
